// extracted by mini-css-extract-plugin
module.exports = {"skipNote":"style_skipNote__3zxAb","pageError":"style_pageError__ldreD","information":"style_information__2uy2y"};